import React, { useEffect } from "react";
import { getGeneralRoutes } from "../utils/routes/Routes";
import DashboardSideMenu from "../components/DashboardSideMenu/DashboardSideMenu";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import FolderView from "./FolderView";
import { createFolder, deleteFile, getFile, getFiles, getFolders, uploadFile } from "./MediaApi";
import cloudStore from "../store/CloudStore";
import SearchForms from "../components/Forms/SearchForms";
import { Paper, Typography } from "@material-ui/core";
import * as CloudActions from "../store/CloudActions";
import { getFilteredMerchants } from "../store/CloudActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import FileView from "./FileView";
import Button from "@material-ui/core/Button";
import { useDialog } from "../components/Dialogs/DialogProvider";
import UploadFile from "./UploadFile";
import CreateFolder from "./CreateFolder";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    width: "100%",
  },
  content: {
    marginTop: 56,
    flexGrow: 1,
    overflow: "scroll",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

function Drive(props) {
  const classes = useStyles();
  const [merchants, setMerchants] = React.useState([]);
  const [merchantsObject, setMerchantsObject] = React.useState({});
  const [root, setRoot] = React.useState({ subfolders: {} });
  const [files, setFiles] = React.useState(null);
  const [selectedPath, setSelectedPath] = React.useState("/");
  const [selectedFolder, setSelectedFolder] = React.useState(root);
  const [loading, setLoading] = React.useState(true);
  const [openDialog, closeDialog] = useDialog();

  useEffect(() => {
    if (cloudStore.merchants == null) {
      getFilteredMerchants().then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  function getFolderForPath(folder, path) {
    if (path.length <= 1) {
      return folder;
    }
    let splitted = path.split("/");

    folder = folder.subfolders["/" + splitted[1]];

    if (splitted.length > 2) {
      return getFolderForPath(folder, path.substr(splitted[1].length + 1));
    }
    return folder;
  }

  useEffect(() => {
    if (!loading) {
      const newMerchants = [...cloudStore.merchants];
      let newMerchantsObject = {};
      newMerchants.forEach((merchant) => {
        newMerchantsObject[merchant.id] = merchant;
      });
      setMerchantsObject(newMerchantsObject);
      setMerchants(newMerchants);
    }
  }, [loading]);

  useEffect(() => {
    getFolders(merchants.map((merchant) => merchant.merchant_id)).then((merchantCollections) => {
      let root = { subfolders: {} };

      function addSubFolder(folder, newFolder) {
        let splitted = newFolder.name.split("/");
        if (!folder.subfolders["/" + splitted[1]]) {
          let fullPathParent = folder.fullPath ?? "";

          folder.subfolders["/" + splitted[1]] = {
            ...newFolder,
            subfolders: {},
            fullPath: fullPathParent + "/" + splitted[1],
          };
        }

        // if (!newFolder.fullPath) {
        //   newFolder.fullPath = newFolder.name;
        // }

        if (splitted.length > 2) {
          newFolder.name = newFolder.name.substr(splitted[1].length + 1);
          return addSubFolder(folder.subfolders["/" + splitted[1]], newFolder);
        }
      }

      Object.keys(merchantCollections).forEach((merchantCollectionKey) => {
        merchantCollections[merchantCollectionKey].forEach((folder) => {
          addSubFolder(root, folder);
        });
      });

      setRoot(root);
    });
  }, [merchants]);

  useEffect(() => {
    if (selectedPath) {
      setFiles(null);
      getFiles(
        merchants.map((merchant) => merchant.merchant_id),
        selectedPath
      ).then((files) => {
        setFiles(files);
      });
    }
    setSelectedFolder(getFolderForPath(root, selectedPath));
  }, [selectedPath, root]);

  if (loading) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <DashboardSideMenu routes={getGeneralRoutes()} />
      <main className={classes.content}>
        <Container className={classes.container} maxWidth={"xl"}>
          <Typography style={{ fontWeight: 800 }}>
            {merchants?.length === 1 ? merchants[0].name : merchants?.map((merchant) => merchant.name + ", ")}
          </Typography>

          {cloudStore.merchants?.length > 1 && (
            <SearchForms
              getValue={(merchant) => merchant.name}
              allResults={cloudStore.merchants ?? []}
              handleSelect={(merchant) => {
                const newMerchants = [...merchants];
                newMerchants.push(merchant);
                setMerchants(newMerchants);
              }}
              selectAll={() => {
                setMerchants(cloudStore.merchants == null ? [] : cloudStore.merchants);
              }}
            />
          )}

          <Typography style={{ margin: 8 }}>file:/{selectedPath}</Typography>

          <div style={{ display: "flex", flexFlow: "wrap", alignItems: "center" }}>
            {selectedPath.length > 1 && (
              <Button
                variant={"outlined"}
                color={"primary"}
                style={{ margin: 8 }}
                onClick={(e) => {
                  let splitted = selectedPath.split("/");
                  splitted.splice(splitted.length - 1, 1);

                  let newPath = splitted.join("/");
                  if (newPath.length === 0) {
                    newPath = "/";
                  }
                  setSelectedPath(newPath);
                }}
              >
                Back
              </Button>
            )}

            {selectedPath.length > 1 && (
              <Button
                variant={"outlined"}
                color={"primary"}
                style={{ margin: 8 }}
                onClick={(e) => {
                  openDialog({
                    children: (
                      <CreateFolder
                        onSubmit={(folderName) => {
                          CloudActions.setLoading(true);
                          createFolder(merchants[0].merchant_id, selectedPath + "/" + folderName)
                            .then(() => {
                              CloudActions.setLoading(false);
                              closeDialog();
                              setMerchants([...merchants]);
                            })
                            .catch(() => {
                              CloudActions.setLoading(false);
                            });
                        }}
                      />
                    ),
                  });
                }}
              >
                Create Folder
              </Button>
            )}

            {selectedPath.length > 1 && (
              <Button
                variant={"outlined"}
                color={"primary"}
                style={{ margin: 8 }}
                onClick={() => {
                  openDialog({
                    children: (
                      <UploadFile
                        merchants={merchants}
                        onSubmit={(merchantId, files) => {
                          CloudActions.setLoading(true);
                          uploadFile(merchantId, selectedPath, files)
                            .then(() => {
                              CloudActions.setLoading(false);
                              closeDialog();
                              setRoot({ ...root });
                            })
                            .catch(() => {
                              CloudActions.setLoading(false);
                            });
                        }}
                      />
                    ),
                  });
                }}
              >
                Upload new file
              </Button>
            )}
          </div>
          <div style={{ display: "flex", flexFlow: "wrap" }}>
            {Object.keys(selectedFolder.subfolders).map((folderName) => {
              let folder = selectedFolder.subfolders[folderName];
              return (
                <FolderView
                  folder={folder}
                  onClick={() => {
                    setSelectedPath(folder.fullPath);
                  }}
                />
              );
            })}
          </div>

          <Divider />

          {selectedPath && files && (
            <>
              {Object.keys(files)
                .sort((a, b) => merchantsObject[a].name.localeCompare(merchantsObject[b].name))
                .map((merchantId) => {
                  let merchantIndex = merchants.findIndex((merchant) => merchant.merchant_id == merchantId);
                  let merchant = null;
                  if (merchantIndex >= 0) {
                    merchant = merchants[merchantIndex];
                  }

                  return (
                    <>
                      {merchants.length > 1 && <Typography variant={"subtitle1"}>{merchant.name}</Typography>}
                      <div style={{ display: "flex", flexFlow: "wrap" }}>
                        {Object.keys(files[merchantId]).map((fileUuid) => {
                          return (
                            <ContextMenuTrigger
                              id="file_context"
                              fileId={files[merchantId][fileUuid].order}
                              merchantId={merchantId}
                              holdToDisplay={3000}
                              collect={(props) => ({
                                fileId: props.fileId,
                                merchantId: merchantId,
                                collectionName: selectedPath,
                              })}
                            >
                              <FileView
                                file={files[merchantId][fileUuid]}
                                onClick={() => {
                                  getFile(merchantId, selectedPath, fileUuid).then((fileUrl) => {
                                    window.open(fileUrl, "_blank").focus();
                                  });
                                }}
                              />
                            </ContextMenuTrigger>
                          );
                        })}
                      </div>
                      <Divider />
                    </>
                  );
                })}
            </>
          )}
          {selectedPath && !files && (
            <div align="center">
              <CircularProgress color="primary" />
            </div>
          )}
          <ContextMenu id="file_context">
            <Paper style={{ padding: 16 }}>
              <MenuItem
                onClick={(e, data, target) => {
                  console.log(e);
                  console.log(data);
                  CloudActions.setLoading(true);
                  deleteFile(data.merchantId, data.collectionName, data.fileId)
                    .then(() => {
                      CloudActions.setLoading(false);
                      closeDialog();
                      setRoot({ ...root });
                    })
                    .catch(() => {
                      CloudActions.setLoading(false);
                    });
                  console.log(target);
                }}
              >
                <Button>Delete</Button>
              </MenuItem>
            </Paper>
          </ContextMenu>
        </Container>
      </main>
    </div>
  );
}

export default Drive;
